import React from "react";
import { Row, Col, Typography, Collapse, Grid } from "antd";
import { SafetyCertificateOutlined } from "@ant-design/icons";
import "./FAQSection.css";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const faqItems = [
  // {
  //   key: "1",
  //   label: "Quanto tempo dura o banho de ouro em semijoias?",
  //   children: (
  //     <p style={{ margin: 0 }}>
  //       A durabilidade pode variar conforme o tipo de peça, uso e cuidados após
  //       o processo. O mais importante é que o banho seja feito com padrão
  //       técnico e controle de qualidade, garantindo um acabamento mais
  //       confiável e uma melhor percepção de valor da peça.
  //     </p>
  //   ),
  // },
  // {
  //   key: "2",
  //   label: "Como funciona o serviço de banho de ouro?",
  //   children: (
  //     <p style={{ margin: 0 }}>
  //       O processo começa com a análise da peça e definição do acabamento
  //       desejado. Depois, realizamos o banho com controle técnico e seguimos
  //       para a conferência final antes da entrega.
  //     </p>
  //   ),
  // },
  {
    key: "3",
    label: "Vocês trabalham com quantidade mínima?",
    children: (
      <p style={{ margin: 0 }}>
        A quantidade pode variar conforme o tipo de serviço e a necessidade da operação. Para o primeiro banho, não estipulamos uma quantidade mínima; no entanto, para as entradas subsequentes, o volume mínimo exigido é de 1kg de mercadoria.

        O ideal é falar com nossa equipe para avaliarmos o volume e indicar a melhor solução para o seu caso.
      </p>
    ),
  },
  {
    key: "4",
    label: "Qual é o prazo médio?",
    children: (
      <p style={{ margin: 0 }}>
        O prazo de entrega depende do tipo de peça, volume e demanda atual do serviço. Para processos específicos, seguimos o cronograma abaixo:

Verniz Diamond: 7 dias.

Verniz Cataforético: 15 dias úteis.

Após entendermos sua necessidade, nossa equipe informará o prazo final mais adequado para a produção e entrega do seu pedido.
      </p>
    ),
  },
  {
    key: "5",
    label: "Vocês atendem marcas, fabricantes e revendedores?",
    children: (
      <p style={{ margin: 0 }}>
        Sim. Nosso atendimento é voltado para operações que precisam de padrão
        visual, consistência no acabamento e mais segurança no processo.
      </p>
    ),
  },
  {
    key: "6",
    label: "Como solicitar um orçamento?",
    children: (
      <p style={{ margin: 0 }}>
        Você pode solicitar orçamento diretamente pela página ou falar com nossa
        equipe para informar o tipo de peça, acabamento desejado e volume
        aproximado.
      </p>
    ),
  },
];

function FAQSection() {
  const screens = useBreakpoint();
  const isDesktop = screens.lg;

  return (
    <section
      style={{
        padding: isDesktop ? "96px 24px" : "72px 16px",
        background: "#ffffff",
      }}
    >
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <Row gutter={isDesktop ? [40, 24] : [0, 28]} align="top">
          <Col xs={24} lg={8}>
            <div style={{ maxWidth: isDesktop ? 440 : "100%" }}>
              <span
                style={{
                  display: "inline-block",
                  padding: isDesktop ? "8px 14px" : "7px 12px",
                  borderRadius: 999,
                  background: "rgba(210,171,113,0.12)",
                  border: "1px solid rgba(210,171,113,0.24)",
                  color: "#a8844f",
                  fontSize: isDesktop ? 13 : 12,
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  marginBottom: 18,
                }}
              >
                DÚVIDAS FREQUENTES
              </span>

              <Title
                level={2}
                style={{
                  marginBottom: 18,
                  color: "#1f1f1f",
                  fontSize: isDesktop ? "clamp(34px, 4vw, 48px)" : "30px",
                  lineHeight: isDesktop ? 1.08 : 1.15,
                }}
              >
                Perguntas que ajudam na sua decisão
              </Title>

              <Paragraph
                style={{
                  fontSize: isDesktop ? 18 : 16,
                  lineHeight: 1.75,
                  color: "#666",
                  marginBottom: 24,
                }}
              >
                Reunimos as principais dúvidas sobre o banho de ouro para
                semijoias para deixar sua decisão mais segura e objetiva.
              </Paragraph>

              <div
                style={{
                  background: "#f8f6f2",
                  borderRadius: isDesktop ? 22 : 18,
                  padding: isDesktop ? "24px 22px" : "20px 18px",
                  border: "1px solid #eadfce",
                  boxShadow: "0 10px 28px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    width: 54,
                    height: 54,
                    borderRadius: 16,
                    background: "linear-gradient(135deg, #d2ab71, #bb9259)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: 24,
                    boxShadow: "0 10px 22px rgba(187,146,89,0.18)",
                    marginBottom: 16,
                  }}
                >
                  <SafetyCertificateOutlined />
                </div>

                <div
                  style={{
                    fontSize: isDesktop ? 20 : 18,
                    fontWeight: 700,
                    color: "#1f1f1f",
                    lineHeight: 1.35,
                    marginBottom: 8,
                  }}
                >
                  Atendimento com mais clareza e segurança
                </div>

                <Paragraph
                  style={{
                    marginBottom: 0,
                    color: "#666",
                    fontSize: isDesktop ? 15 : 14,
                    lineHeight: 1.65,
                  }}
                >
                  Nosso objetivo é deixar o processo mais simples, claro e
                  alinhado com a necessidade da sua operação.
                </Paragraph>
              </div>
            </div>
          </Col>

          <Col xs={24} lg={16}>
            <div
              style={{
                background: "#fff",
                borderRadius: isDesktop ? 28 : 22,
                border: "1px solid #eadfce",
                boxShadow: "0 14px 36px rgba(0,0,0,0.05)",
                padding: isDesktop ? 18 : 10,
              }}
            >
              <Collapse
                accordion
                ghost
                items={faqItems}
                expandIconPosition="end"
                style={{
                  background: "transparent",
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default FAQSection;